/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateUserRequestFromJSON(json) {
    return StreemApiUpdateUserRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'avatarUrl': !exists(json, 'avatar_url') ? undefined : json['avatar_url'],
        'bio': !exists(json, 'bio') ? undefined : json['bio'],
    };
}
export function StreemApiUpdateUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'avatar_url': value.avatarUrl,
        'bio': value.bio,
    };
}
//# sourceMappingURL=StreemApiUpdateUserRequest.js.map